import React from "react";

const NoMatch = () => {
  return <>NoMatch</>;
};

export default NoMatch;
